(() => {
  const getRoot = () => document.querySelector('.fallback-modern-product');

  const syncBuybar = () => {
    const root = getRoot();
    if (!root) return;

    const barButton = root.querySelector('[data-fallback-buybar-button]');
    const barPrice = root.querySelector('[data-fallback-buybar-price]');
    const mainButton = root.querySelector('.product-form__submit');
    const price = root.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular');

    if (barPrice && price) barPrice.textContent = price.textContent.trim();
    if (barButton && mainButton) {
      barButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      const label = mainButton.querySelector('span')?.textContent?.trim();
      if (label) barButton.textContent = label;
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fallback-buybar-button]');
    if (!trigger) return;
    const mainButton = getRoot()?.querySelector('.product-form__submit');
    if (mainButton && !mainButton.disabled) mainButton.click();
  });

  document.addEventListener('DOMContentLoaded', syncBuybar);
  document.addEventListener('product-info:loaded', syncBuybar);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(syncBuybar));
  }
})();

(() => {
  let previousFocus = null;

  const getModal = () => document.querySelector('[data-fallback-size-guide]');

  const openSizeGuide = () => {
    const modal = getModal();
    if (!modal) return;
    previousFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('fallback-size-guide-open');
    requestAnimationFrame(() => modal.querySelector('.fallback-size-guide__close')?.focus());
  };

  const closeSizeGuide = () => {
    const modal = getModal();
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('fallback-size-guide-open');
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-fallback-size-guide-open]')) {
      event.preventDefault();
      openSizeGuide();
      return;
    }
    if (event.target.closest('[data-fallback-size-guide-close]')) {
      event.preventDefault();
      closeSizeGuide();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeSizeGuide();
  });
})();

(() => {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fallback-size-unit]');
    if (!button) return;

    const guide = button.closest('[data-fallback-size-guide]');
    if (!guide) return;

    const unit = button.dataset.fallbackSizeUnit;
    guide.querySelectorAll('[data-fallback-size-unit]').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    guide.querySelectorAll('[data-size-in]').forEach((item) => {
      item.hidden = unit !== 'in';
    });
    guide.querySelectorAll('[data-size-cm]').forEach((item) => {
      item.hidden = unit !== 'cm';
    });
  });
})();
